import { Stack, SxProps, Typography, useTheme } from "@mui/material";
import { CheckCircleIcon, TextArea } from "components";
import { useContext } from "react";
import { FeedbackContext } from "../context";

export const OtherCustomInput = ({
  isSelected,
  onClick,
  sx,
  customReasonLabel,
  customReasonId,
  customRows,
  placeholder,
}: {
  isSelected: boolean;
  onClick: () => void;
  sx?: SxProps;
  customReasonLabel?: string;
  customReasonId?: string;
  customRows?: number;
  placeholder?: string;
}) => {
  const theme = useTheme();
  const context = useContext(FeedbackContext);
  if (!context) throw new Error("wrong context provided");
  const {
    otherCustomValue,
    setOtherCustomValue,
    toolSwitchedTo,
    setToolSwitchedTo,
  } = context;

  const value =
    customReasonId && customReasonId === "switched-to-another-tool"
      ? toolSwitchedTo
      : otherCustomValue;

  const setValue =
    customReasonId && customReasonId === "switched-to-another-tool"
      ? setToolSwitchedTo
      : setOtherCustomValue;

  return (
    <Stack
      justifyContent={"space-between"}
      gap="16px"
      border={`1px solid ${
        isSelected ? theme.palette.primary.main : theme.palette.neutral["015"]
      }`}
      bgcolor={isSelected ? theme.palette.neutral["B-005"] : "transparent"}
      p="14px 16px"
      borderRadius="8px"
      flex={1}
      sx={{
        cursor: "pointer",
        transition: "all 0.3s",
        userSelect: "none",
        ":hover": {
          bgcolor: theme.palette.neutral["B-005"],
        },
        ...sx,
      }}
      onClick={onClick}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={"space-between"}
      >
        <Typography
          variant="body-medium"
          color={
            isSelected ? theme.palette.primary.main : theme.palette.lightBg.low
          }
        >
          {customReasonLabel || "Other"}
        </Typography>
        <CheckCircleIcon
          style={{
            width: "20px",
            height: "20px",
            marginTop: "2px",
            visibility: isSelected ? "visible" : "hidden",
          }}
          color="primary"
        />
      </Stack>
      {isSelected && (
        <TextArea
          name="other"
          placeholder={placeholder || "Enter text"}
          minRows={customRows || 3}
          maxRows={customRows || 3}
          sx={{
            width: "100%",
            padding: "8px",
            resize: "none",
          }}
          hideHelperBox={true}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          autoFocus={true}
        />
      )}
    </Stack>
  );
};
